import { STORAGE_PREFIX } from 'config';

type SetStorageItem = {
  key: string;
  values: unknown;
  storageType: 'local' | 'session';
};
type GetStorageItem = { key: string; storageType: 'local' | 'session' };
type ClearStorageItem = { key: string; storageType: 'local' | 'session' };

export const storage = {
  // eslint-disable-next-line consistent-return
  getItem: ({ key, storageType }: GetStorageItem): any => {
    if (storageType === 'local') {
      const localItemExists = window.localStorage.getItem(
        `${STORAGE_PREFIX}${key}`,
      );
      if (localItemExists) {
        return JSON.parse(localItemExists);
      }
    } else if (storageType === 'session') {
      const sessionItemExists = window.sessionStorage.getItem(
        `${STORAGE_PREFIX}${key}`,
      );
      if (sessionItemExists) {
        return JSON.parse(sessionItemExists);
      }
    }
  },
  // eslint-disable-next-line consistent-return
  setItem: ({ key, values, storageType }: SetStorageItem): void => {
    if (storageType === 'local') {
      return window.localStorage.setItem(
        `${STORAGE_PREFIX}${key}`,
        JSON.stringify(values),
      );
    }
    if (storageType === 'session') {
      return window.sessionStorage.setItem(
        `${STORAGE_PREFIX}${key}`,
        JSON.stringify(values),
      );
    }
  },
  // eslint-disable-next-line consistent-return
  clearItem: ({ key, storageType }: ClearStorageItem): void => {
    if (storageType === 'local') {
      return window.localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
    }
    if (storageType === 'session') {
      return window.sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
    }
  },
  clearAll: () => {
    localStorage.clear();
    sessionStorage.clear();
  },
};
